import DealTickerFilter from './components/DealTickerFilter/DealTickerFilter';

const dealTicker = document.getElementById('deal-ticker');
if (dealTicker) {
  new DealTickerFilter(dealTicker)
}
